export const toastrLocaleDict = {
    ru: {
        deleteTitle: 'Вы уверены?',
        deleteConfirmText: 'Вы уверены, что Вы хотите удалить запись? Это действие необратимо! Продолжить?',
        deleteButton: 'Удалить!',
        cancelButton: 'Отмена',
        errorTitle: 'Внимание!',
        serverErrorText: 'Не был получен ответ от сервера. Возможно, изменения не сохранились. Попробуйте еще раз.'
    },
    en: {
        deleteTitle: 'Are you sure?',
        deleteConfirmText: 'Are you sure you want to delete the record? This action cannot be undone. Continue?',
        deleteButton: 'Delete!',
        cancelButton: 'Cancel',
        errorTitle: 'Attention!',
        serverErrorText: 'No response was received from the server. Changes may not have been saved. Please try again.'
    },
    th: {
        deleteTitle: 'คุณแน่ใจหรือไม่?',
        deleteConfirmText: 'คุณแน่ใจหรือไม่ว่าต้องการลบรายการนี้? การดำเนินการนี้ไม่สามารถยกเลิกได้ ดำเนินการต่อ?',
        deleteButton: 'ลบ!',
        cancelButton: 'ยกเลิก',
        errorTitle: 'ระวัง!',
        serverErrorText: 'ไม่ได้รับการตอบกลับจากเซิร์ฟเวอร์ การเปลี่ยนแปลงอาจไม่ถูกบันทึก โปรดลองอีกครั้ง'
    },
    tr: {
        deleteTitle: 'Emin misiniz?',
        deleteConfirmText: 'Kaydı silmek istediğinizden emin misiniz? Bu işlem geri alınamaz! Devam edilsin mi?',
        deleteButton: 'Sil!',
        cancelButton: 'İptal',
        errorTitle: 'Dikkat!',
        serverErrorText: 'Sunucudan yanıt alınamadı. Değişiklikler kaydedilmemiş olabilir. Lütfen tekrar deneyin.'
    }
};
